import { Dropdown, Icon, Portal, Ref } from "semantic-ui-react";

import React, { useRef, useState } from "react";
import useEvent from "react-use/lib/useEvent";

import renderChildren from "../../../../utils/renderChildren";

export default function DropdownPortal({
	icon = "ellipsis vertical",
	size,
	color,
	fluid = false,
	options,
	direction = "left",
	maxHeight = "80vh",
	children,
}) {
	const ref = useRef();
	const [open, setOpen] = useState(false);
	const [{ x, y }, setPosition] = useState({ x: 0, y: 0 });

	useEvent("click", open && (() => setOpen(false)));
	useEvent("scroll", open && (() => setOpen(false)));

	const onClick = (event) => {
		event.stopPropagation();

		setPosition({
			x: event.pageX - window.scrollX,
			y: event.pageY - window.scrollY,
		});

		setOpen((open) => !open);
	};

	return (
		<Portal
			open={open}
			trigger={
				children ? (
					renderChildren(children, { onClick })
				) : (
					<Icon
						name={icon}
						size={size}
						color={color}
						style={{
							position: fluid && "absolute",
							display: "flex",
							top: 0,
							left: 0,
							margin: 0,
							width: "100%",
							height: "100%",
							justifyContent: "center",
							alignItems: "center",
						}}
						onClick={onClick}
					/>
				)
			}
		>
			<Ref innerRef={ref}>
				<Dropdown
					open
					icon={false}
					scrolling
					direction={direction}
					style={{
						position: "fixed",
						top: y,
						left: x,
						zIndex: 1000,
					}}
				>
					<Dropdown.Menu style={{ maxHeight }}>
						{options.map((option, index) => {
							if (option.type === "divider") {
								return <Dropdown.Divider key={index} />;
							}

							return <Dropdown.Item key={index} {...option} />;
						})}
					</Dropdown.Menu>
				</Dropdown>
			</Ref>
		</Portal>
	);
}
